// Validation utility functions
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePhoneNumber = (mobile) => {
  if (!mobile || !mobile.trim()) return false;
  const normalized = mobile.trim().replace(/\s/g, "");
  return /^\+[1-9]\d{6,14}$/.test(normalized);
};

export const validatePassword = (password) => {
  // At least 8 characters, 1 uppercase, 1 lowercase, 1 number
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
  return passwordRegex.test(password);
};

export const getPasswordStrength = (password) => {
  let strength = 0;
  let feedback = [];

  // ✅ FIXED: 8 characters is mandatory for any strength
  if (password.length >= 8) {
    strength++;
  } else {
    feedback.push('At least 8 characters');
    // If less than 8 characters, return weak strength regardless of other criteria
    return { strength: 1, feedback };
  }

  if (/[a-z]/.test(password)) strength++;
  else feedback.push('One lowercase letter');

  if (/[A-Z]/.test(password)) strength++;
  else feedback.push('One uppercase letter');

  if (/\d/.test(password)) strength++;
  else feedback.push('One number');

  // Removed special character validation
  // if (/[@$!%*?&]/.test(password)) strength++;
  // else feedback.push('One special character (@$!%*?&)');

  return { strength, feedback };
};

export const validateForm = (formData, formType) => {
  const errors = {};

  if (formType === 'register') {
    // ✅ REMOVED: First name and last name validation

    // Email validation
    if (!formData.email || !formData.email.trim()) {
      errors.email = 'Email is required';
    } else if (!validateEmail(formData.email)) {
      errors.email = 'Please enter a valid email address';
    }

    // Mobile validation
    if (!formData.mobile || !formData.mobile.trim()) {
      errors.mobile = 'Phone number is required';
    } else if (!validatePhoneNumber(formData.mobile)) {
      errors.mobile = 'Please enter a valid phone number with country code';
    } else if (formData.mobile.replace(/\s/g, '').length > 20) {
      errors.mobile = 'Phone number is too long';
    }

    // Password validation
    if (!formData.password || !formData.password.trim()) {
      errors.password = 'Password is required';
    } else if (!validatePassword(formData.password)) {
      errors.password = 'Password must be at least 8 characters with uppercase, lowercase, and number';
    }

    // Confirm password validation
    if (!formData.confirmPassword || !formData.confirmPassword.trim()) {
      errors.confirmPassword = 'Please confirm your password';
    } else if (formData.password !== formData.confirmPassword) {
      errors.confirmPassword = 'Passwords do not match';
    }

    // reCAPTCHA validation
    if (!formData.recaptcha) {
      errors.recaptcha = 'Please complete the reCAPTCHA verification';
    }
  }

  if (formType === 'login') {
    // Email validation
    if (!formData.email || !formData.email.trim()) {
      errors.email = 'Email is required';
    } else if (!validateEmail(formData.email)) {
      errors.email = 'Please enter a valid email address';
    }

    // Password validation
    if (!formData.password || !formData.password.trim()) {
      errors.password = 'Password is required';
    }

    // reCAPTCHA validation
    if (!formData.recaptcha) {
      errors.recaptcha = 'Please complete the reCAPTCHA verification';
    }
  }

  if (formType === 'resetPassword') {
    // Password validation
    if (!formData.password || !formData.password.trim()) {
      errors.password = 'Password is required';
    } else if (!validatePassword(formData.password)) {
      errors.password = 'Password must be at least 8 characters with uppercase, lowercase, and number';
    }

    // Confirm password validation
    if (!formData.confirmPassword || !formData.confirmPassword.trim()) {
      errors.confirmPassword = 'Please confirm your password';
    } else if (formData.password !== formData.confirmPassword) {
      errors.confirmPassword = 'Passwords do not match';
    }
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};
